import React, {useState, useEffect} from "react";
//import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import moment from "moment";
import { Link } from "react-router-dom";
import "./../../Public/css/bootstrap.min.css";
import "./../../Public/css/tabler-icons.css";
import "./../../Public/css/fontawesome.min.css";
import "./../../Public/css/all.min.css";
import "./../../Public/css/style.css";

import {DashboardAPI, DashboardFilterAPI, getCampaignsAPI, getCallersAPI} from "./../../API/Team/DashboardAPI";
import Sidebar from "./Common/Sidebar";
import Header from "./Common/Header";
import Loader from "./../Loader";


const Dashboard = () =>{

	const [freshleadcount, setFreshLeadCount] = useState(0);
	const [warmleadcount, setWarmLeadCount] = useState(0);
	const [todayfollowup, setTodayFollowup] = useState(0);
	const [pendingfollowup, setPendingFollowup] = useState(0);

	/*const [contactedleadcount, setContactedLeadCount] = useState(0);
	const [deadleadcount, setDeadLeadCount] = useState(0);
	const [coldleadcount, setColdLeadCount] = useState(0);
	const [attemptleadcount, setAttemptLeadCount] = useState(0);
	const [enrolledleadcount, setEnrolledLeadCount] = useState(0);
	const [totalleadcount, setTotalLeadCount] = useState(0);*/
	
	const [loggedname, setLoggedName] = useState("");

	const [callerdata, setCallerData] = useState([]);
	const [loading, setLoading] = useState(true);
	const [notifications, setNotifications] = useState([]);
	const [campaigns, setCampaigns] = useState([]);
	const [callers, setCallers] = useState([]);
	const [filtercampaign, setFilterCampaign] = useState("");
	const [filtercaller, setFilterCaller] = useState("");
	const [filterstartdate, setFilterStartdate] = useState("");
	const [filterenddate, setFilterEnddate] = useState("");
	const [filterparam, setFilterParam] = useState("");

	const current = moment();

	useEffect(() =>{

		const userinfo = localStorage.getItem("userinfo");

		if(userinfo !== "" && userinfo !== null && userinfo !== undefined)
        {
            const loggeduserdata = JSON.parse(userinfo);

            setLoggedName(loggeduserdata.name);
        }

		DashboardAPI(setFreshLeadCount, setWarmLeadCount, setPendingFollowup, setTodayFollowup, setNotifications, setCallerData, setLoading);

		getCampaignsAPI(setCampaigns);
		
	}, []);

	const handleReloadStats = () =>{

	}

	const handleFilterCampaign = (e) =>{
		setFilterCampaign(e.target.value);

		getCallersAPI(e.target.value, setCallers);
	}

	const handleFilterCaller = (e) =>{
		setFilterCaller(e.target.value);
	}

	const handleStartDate = (e) =>{
		setFilterStartdate(e.target.value);
	}

	const handleEndDate = (e) =>{
		setFilterEnddate(e.target.value);
	}

	const handleFilterDashboardCounts = (e) =>{
		const filterparams = new URLSearchParams();

        if(filtercampaign)
        {
            filterparams.append('filter_campaignid', filtercampaign);
        }

        if(filtercaller)
        {
            filterparams.append('filter_callerid', filtercaller);
        }

        if(filterstartdate)
        {
            filterparams.append('filter_startdate', filterstartdate);
        }

		if(filterenddate)
        {
            filterparams.append('filter_enddate', filterenddate);
        }

		//setFilterParam('?' + filterparams);

        DashboardFilterAPI(filterparams, setFreshLeadCount, setWarmLeadCount, setPendingFollowup, setTodayFollowup, setNotifications, setLoading, setFilterParam);
	}


    return(
	<div className="main-wrapper">

		<Loader />

		<Header />

		<Sidebar />

		<div className="page-wrapper">
			<div className="content">
				{/*<div className="row">
					<div className="col-md-12">
						<div className="page-header">
							<div className="row align-items-center ">
								<div className="col-md-4">
									<h3 className="page-title">Leads Dashboard</h3>
								</div>
								<div className="col-md-8 float-end ms-auto">
									<div className="d-flex title-head">
										<div className="daterange-picker d-flex align-items-center justify-content-center">
											
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>*/}

				<div class="welcome-wrap mb-4">
					<div class=" d-flex align-items-center justify-content-between flex-wrap">
						<div class="mb-3">
							<h2 class="mb-1 text-white">Welcome {loggedname}</h2>
							<p class="text-light">As of {current.format('DD MMMM YYYY')} {current.format('hh:mm A')}</p>
						</div>
						<div class="d-flex align-items-center flex-wrap mb-1">
							{/*<a href="company.html" class="btn btn-dark btn-md me-2 mb-2">Companies</a>*/}
							<button type="button" class="btn btn-light btn-md mb-2" onClick={handleReloadStats}>Refresh</button>
						</div>
					</div>
				</div>

				<div className="row">
					<div className="col-md-12">
						<div className="page-header">
							<div className="row align-items-center ">
								<div className="col-md-12 ms-auto">
									<div className="d-flex title-head">
										<div className="d-flex col-md-2 align-items-center justify-content-center me-2">
											<select className="form-control" name="campaign" value={filtercampaign} onChange={handleFilterCampaign}>
												<option value="">Select Campaigns</option>
												{campaigns && campaigns.map(campaigndata =>(
												<option key={campaigndata.id} value={campaigndata.id}>{campaigndata.name}</option>		
												))}
											</select>
										</div>

										<div className="d-flex col-md-2 align-items-center justify-content-center me-2">
											<select className="form-control" name="caller" value={filtercaller} onChange={handleFilterCaller}>
												<option value="">Select Caller</option>
												{callers.map(callerdata =>(
												<option key={callerdata.id} value={callerdata.id}>{callerdata.name}</option>		
												))}
											</select>
										</div>

										<div className="d-flex col-md-4 align-items-center justify-content-center me-2">
											<input type="date" className="form-control me-2" name="startdate" value={filterstartdate} onChange={handleStartDate} />
											<input type="date" className="form-control" name="enddate" value={filterenddate} onChange={handleEndDate} />
										</div>

										<div className="button-filter me-2">
											<button type="button" className="btn btn-primary" onClick={handleFilterDashboardCounts}>
												<i className="ti ti-search me-2"></i>Apply Filter
											</button>
											
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="row">
					<div className="col-md-8">
						<div className="row">
							<div className="col-md-4">
								<div className="card">
									<div className="card-body p-3 d-flex align-items-center mx-auto">                            	
										<div>
											<div className="fs-25 fw-semibold widget-text text-center">{freshleadcount}</div>
											<div className="text-body-secondary fw-semibold widget-heading">Fresh Leads</div>
										</div>
									</div>
									<div className="card-footer widget-card-footer px-3 py-2">
										<Link className="btn-block text-body-secondary d-flex justify-content-between align-items-center" to={`/team/lead/freshlead${filterparam}`}>
											<span className="small fw-semibold">View all</span>

											<svg xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  strokeWidth="2"  strokeLinecap="round"  strokeLinejoin="round"  className="icon icon-tabler icons-tabler-outline icon-tabler-arrow-right">
												<path stroke="none" d="M0 0h24v24H0z" fill="none"/>
												<path d="M5 12l14 0" />
												<path d="M13 18l6 -6" />
												<path d="M13 6l6 6" />
											</svg>
										</Link>
									</div>
								</div>
							</div>
							<div className="col-md-4">
								<div className="card">
									<div className="card-body p-3 d-flex align-items-center mx-auto">                            	
										<div>
											<div className="fs-25 fw-semibold widget-text text-center">{todayfollowup}</div>
											<div className="text-body-secondary fw-semibold widget-heading">Follow Up for Today</div>
										</div>
									</div>
									<div className="card-footer widget-card-footer px-3 py-2">
										<Link className="btn-block text-body-secondary d-flex justify-content-between align-items-center" to={`/team/notification/today${filterparam}`}>
											<span className="small fw-semibold">View all</span>

											<svg xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  strokeWidth="2"  strokeLinecap="round"  strokeLinejoin="round"  className="icon icon-tabler icons-tabler-outline icon-tabler-arrow-right">
												<path stroke="none" d="M0 0h24v24H0z" fill="none"/>
												<path d="M5 12l14 0" />
												<path d="M13 18l6 -6" />
												<path d="M13 6l6 6" />
											</svg>
										</Link>
									</div>
								</div>
							</div>

							<div className="col-md-4">
								<div className="card">
									<div className="card-body p-3 d-flex align-items-center mx-auto">                            	
										<div>
											<div className="fs-25 fw-semibold widget-text text-center">{warmleadcount}</div>
											<div className="text-body-secondary fw-semibold widget-heading">Warm Leads</div>
										</div>
									</div>
									<div className="card-footer widget-card-footer px-3 py-2">
										<Link className="btn-block text-body-secondary d-flex justify-content-between align-items-center" to={`/team/lead/warmleads${filterparam}`}>
											<span className="small fw-semibold">View all</span>

											<svg  className="icon" xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-arrow-right">
												<path stroke="none" d="M0 0h24v24H0z" fill="none"/>
												<path d="M5 12l14 0" />
												<path d="M13 18l6 -6" />
												<path d="M13 6l6 6" />
											</svg>
										</Link>
									</div>
								</div>
							</div>

							<div className="col-md-4">
								<div className="card">
									<div className="card-body p-3 d-flex align-items-center mx-auto">                            	
										<div>
											<div className="fs-25 fw-semibold widget-text text-center">{pendingfollowup}</div>
											<div className="text-body-secondary fw-semibold widget-heading">Pending Follow Ups</div>
										</div>
									</div>
									<div className="card-footer widget-card-footer px-3 py-2">
										<Link className="btn-block text-body-secondary d-flex justify-content-between align-items-center" to={`/team/notification/pending${filterparam}`}>
											<span className="small fw-semibold">View all</span>

											<svg xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  strokeWidth="2"  strokeLinecap="round"  strokeLinejoin="round"  className="icon icon-tabler icons-tabler-outline icon-tabler-arrow-right">
												<path stroke="none" d="M0 0h24v24H0z" fill="none"/>
												<path d="M5 12l14 0" />
												<path d="M13 18l6 -6" />
												<path d="M13 6l6 6" />
											</svg>
										</Link>
									</div>
								</div>
							</div>

						</div>
					</div>

					<div className="col-md-4">
						<div class="card flex-fill">
							<div class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
								<h5 class="mb-2">Today Follow Ups</h5>
								<Link to="/team/notifications" class="btn btn-light btn-md mb-2">View All</Link>
							</div>
							<div class="card-body pb-2 notify-bar">
								{notifications && notifications.length > 0  ? 
									( notifications.map(notification => 
										(
											<div class="d-sm-flex justify-content-between flex-wrap mb-3">
												<div class="d-flex align-items-center mb-2">                                         
													<div class="avatar avatar-sm border flex-shrink-0">
														<span class="initials">JD</span>
													</div>
													<div class="ms-2 flex-fill">
														<h6 class="fs-medium text-truncate mb-1">
															<a href="javscript:void(0);">{notification.name}</a>
														</h6>
														<p class="fs-13 d-inline-flex align-items-center">
															<span class="text-info">{notification.contact}</span>
														</p>
													</div>
												</div>
												<div class="text-sm-end mb-2">
													<h6 class="mb-1">{moment(notification.display_date).format('DD MMM YYYY')} {notification.display_time}</h6>
												</div>
											</div>
										)
									))
								:
									<p className="centered-message">No data found</p>
								}
								{/*<div class="d-sm-flex justify-content-between flex-wrap mb-3">
									<div class="d-flex align-items-center mb-2">                                         
										<div class="avatar avatar-sm border flex-shrink-0">
											<span class="initials">JD</span>
										</div>
										<div class="ms-2 flex-fill">
											<h6 class="fs-medium text-truncate mb-1"><a href="javscript:void(0);">NovaWave LLC</a></h6>
											<p class="fs-13 d-inline-flex align-items-center"><span class="text-info">#12457</span><i class="ti ti-circle-filled fs-4 text-primary mx-1"></i>14 Jan 2025</p>
										</div>
									</div>
									<div class="text-sm-end mb-2">
										<h6 class="mb-1">+$245</h6>
										<p class="fs-13">Basic (Monthly)</p>
									</div>
								</div>
								<div class="d-sm-flex justify-content-between flex-wrap mb-3">
									<div class="d-flex align-items-center mb-2">                                           
										<a href="javscript:void(0);" class="avatar avatar-sm border flex-shrink-0">
											<div class="avatar">
												<span class="initials">JD</span>
											</div>
										</a>
										<div class="ms-2 flex-fill">
											<h6 class="fs-medium text-truncate mb-1"><a href="javscript:void(0);">BlueSky Industries</a></h6>
											<p class="fs-13 d-inline-flex align-items-center"><span class="text-info">#65974</span><i class="ti ti-circle-filled fs-4 text-primary mx-1"></i>14 Jan 2025</p>
										</div>
									</div>
									<div class="text-sm-end mb-2">
										<h6 class="mb-1">+$395</h6>
										<p class="fs-13">Enterprise (Yearly)</p>
									</div>
								</div>
								<div class="d-sm-flex justify-content-between flex-wrap mb-3">
									<div class="d-flex align-items-center mb-2">                                           
										<a href="javscript:void(0);" class="avatar avatar-sm border flex-shrink-0">
											<div class="avatar">
												<span class="initials">JD</span>
											</div>
										</a>
										<div class="ms-2 flex-fill">
											<h6 class="fs-medium text-truncate mb-1"><a href="javscript:void(0);">Silver Hawk</a></h6>
											<p class="fs-13 d-inline-flex align-items-center"><span class="text-info">#22457</span><i class="ti ti-circle-filled fs-4 text-primary mx-1"></i>14 Jan 2025</p>
										</div>
									</div>
									<div class="text-sm-end mb-2">
										<h6 class="mb-1">+$145</h6>
										<p class="fs-13">Advanced (Monthly)</p>
									</div>
								</div>
								<div class="d-sm-flex justify-content-between flex-wrap mb-3">
									<div class="d-flex align-items-center mb-2">                                        
										<a href="javscript:void(0);" class="avatar avatar-sm border flex-shrink-0">
											<div class="avatar">
												<span class="initials">JD</span>
											</div>
										</a>
										<div class="ms-2 flex-fill">
											<h6 class="fs-medium text-truncate mb-1"><a href="javscript:void(0);">Summit  Peak</a></h6>
											<p class="fs-13 d-inline-flex align-items-center"><span class="text-info">#43412</span><i class="ti ti-circle-filled fs-4 text-primary mx-1"></i>14 Jan 2025</p>
										</div>
									</div>
									<div class="text-sm-end mb-2">
										<h6 class="mb-1">+$145</h6>
										<p class="fs-13">Enterprise (Monthly)</p>
									</div>
								</div>
								<div class="d-sm-flex justify-content-between flex-wrap mb-1">
									<div class="d-flex align-items-center mb-2">                                           
										<a href="javscript:void(0);" class="avatar avatar-sm border flex-shrink-0">
											<div class="avatar">
												<span class="initials">JD</span>
											</div>
										</a>
										<div class="ms-2 flex-fill">
											<h6 class="fs-medium text-truncate mb-1"><a href="javscript:void(0);">RiverStone Ventur</a></h6>
											<p class="fs-13 d-inline-flex align-items-center"><span class="text-info">#43567</span><i class="ti ti-circle-filled fs-4 text-primary mx-1"></i>14 Jan 2025</p>
										</div>
									</div>
									<div class="text-sm-end mb-2">
										<h6 class="mb-1">+$977</h6>
										<p class="fs-13">Premium (Yearly)</p>
									</div>
								</div>*/}
							</div>
						</div>
					</div>					
				</div>

				<div className="row">
					<div className="col-md-12">
						<div className="card w-100">
							<div className="card-header border-0 pb-0">
								<h4><i className="ti ti-grip-vertical me-1"></i>Caller Leads Report</h4>
							</div>
							<div className="card-body">
								<div className="table-responsive">
                                    <table className="table table-nowrap mb-0" id="">
                                        <thead className="thead-light">
                                            <tr>
                                                <th>Caller Name</th>
                                                <th>Fresh</th>
                                                <th>Warm</th>
                                                <th>Today Follow Ups</th>
                                                <th>Pending Follow Ups</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                    
                                        {loading ?
                                            <tr>
                                                <td colSpan="5">
                                                    <Loader />
                                                </td>
                                            </tr>
                                        :
                                            (callerdata && callerdata.length > 0  ? 
                                                ( callerdata.map(caller => 
                                                    (
                                            
                                                        <tr key={caller.id}>
                                                            <td>
																<div class="avatar avatar-sm border flex-shrink-0 me-2">
																	<span class="initials">{(caller.name).slice(0,2)}</span>
																</div>
																{caller.name}
															</td>
                                                            <td>{caller.freshcount}</td>
                                                            <td>{caller.warmcount}</td>
                                                            <td>{caller.todayfollowup}</td>
                                                            <td>{caller.totalpendingfollowup}</td>
                                                        </tr>
                                                    )
                                                ))
                                            
                                            :
                                        
                                                <tr>
                                                    <td colSpan="5">
                                                        <p>No record found...</p>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    
                                        </tbody>
                                    </table>
                                    
                                </div>
							</div>
						</div>
					</div>
				</div>
				
			</div>
		</div>
	</div>
    )
}

export default Dashboard;